import AuthContainer from '../../components/auth/AuthContainer';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Login = () => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="auth-page-layout">
        <AuthContainer />
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
